import { render, staticRenderFns } from "./VacationRequests.vue?vue&type=template&id=681cd4ba&scoped=true&"
import script from "./VacationRequests.vue?vue&type=script&lang=js&"
export * from "./VacationRequests.vue?vue&type=script&lang=js&"
import style0 from "./VacationRequests.vue?vue&type=style&index=0&id=681cd4ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681cd4ba",
  null
  
)

export default component.exports